import { render, staticRenderFns } from "./documents-item.vue?vue&type=template&id=bee1c59c&scoped=true"
import script from "./documents-item.vue?vue&type=script&lang=js"
export * from "./documents-item.vue?vue&type=script&lang=js"
import style0 from "./documents-item.vue?vue&type=style&index=0&id=bee1c59c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee1c59c",
  null
  
)

export default component.exports